const noticeError = (error, customAttributes = {}) => {
  const { newrelic } = window

  if (!newrelic?.noticeError) return null

  return newrelic.noticeError(error, customAttributes)
}

export default { noticeError }
